import React, { useState } from "react";
import { Toaster } from "@/components/ui/toaster";
import { CalculatorForm, CalculatorInputs } from "@/components/CalculatorForm";
import { CalculatorResults } from "@/components/CalculatorResults";
import { calculateHiringResults } from "@/utils/calculatorResultsHelpers";

interface HeroProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  buttonTarget: string;
}

interface IndexProps {
  heroProps: HeroProps;
}

const Index = ({ heroProps }: IndexProps) => {
  const [results, setResults] = useState<ReturnType<typeof calculateHiringResults> | null>(null);

  const handleCalculate = (inputs: CalculatorInputs) => {
    const calculatedResults = calculateHiringResults(inputs);
    setResults(calculatedResults);
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const href = e.currentTarget.getAttribute('href');
    console.log(href);
    if (href?.startsWith('#')) {
      e.preventDefault();
      console.log('inside if');
      const targetId = href.slice(1);
      
      // Get the shadow root container
      const shadowHost = document.querySelector('talentful-calculator');
      const shadowRoot = shadowHost?.shadowRoot;
      const targetElement = shadowRoot?.getElementById(targetId);
      
      console.log('shadow root:', shadowRoot);
      console.log('target element:', targetElement);
      
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const { title, description, buttonText, buttonLink, buttonTarget } = heroProps;
  const hasHeroContent = title || description || buttonText;

  return (
    <div className="space-y-12">
      {hasHeroContent && (
        <div className="flex flex-col items-center gap-12 py-16">
          <div className="flex-1 space-y-6 text-center">
            {title && (
              <h1 className="text-5xl lg:text-6xl font-bold leading-tight" dangerouslySetInnerHTML={{ __html: title }} />
            )}
            {description && (
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">{description}</p>
            )}
            {buttonText && (
              <div className="flex flex-col sm:flex-row justify-center gap-4 pt-4">
                {buttonLink ? (
                  <a 
                    href={buttonLink} 
                    target={buttonLink.startsWith('#') ? undefined : buttonTarget || undefined}
                    onClick={buttonLink.startsWith('#') ? handleButtonClick : undefined} 
                    className="inline-block"
                  >
                    <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 bg-[#FF6F61] hover:bg-[#FF5B4D] text-white px-8 py-6 text-lg rounded-full">
                      {buttonText}
                    </button>
                  </a>
                ) : (
                  <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 bg-[#FF6F61] hover:bg-[#FF5B4D] text-white px-8 py-6 text-lg rounded-full">
                    {buttonText}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <div id="calculator-section" className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
        <CalculatorForm onCalculate={handleCalculate} />
      </div>
      {results && (
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          <CalculatorResults {...results} />
        </div>
      )}
    </div>
  );
};

export default Index;